// @ts-nocheck
import React from 'react';

const AuthVisualPanel = () => (
  <aside className="stage hidden lg:flex flex-col justify-between p-12 lg:p-14 gap-8 relative" aria-hidden="true">
    <div className="relative flex justify-between items-center text-mov-ink-soft mono text-[11px] uppercase" style={{ letterSpacing: '0.12em' }}>
      <span>System status</span>
      <span className="inline-flex items-center gap-2">
        <span className="w-[7px] h-[7px] rounded-full bg-mov-green animate-ping2" style={{ boxShadow: '0 0 0 4px #ecf3df' }} />
        <span>Live · Recovering</span>
      </span>
    </div>

    <div className="relative max-w-[520px]">
      <div className="stage-eyebrow-rule mono text-[11px] uppercase font-medium mb-[18px]" style={{ letterSpacing: '0.16em', color: '#3a4a2a' }}>
        Abandonment Recovery
      </div>
      <h2 className="display text-[38px] leading-[1.1] text-mov-ink m-0 mb-3">
        Win back the <em>92% of visitors</em> who leave without converting.
      </h2>
      <p className="text-mov-ink-soft text-[14px] leading-[1.55] m-0 max-w-[420px]">
        Identify anonymous traffic, reach them by email, and pull them back into your funnel — automatically.
      </p>
    </div>

    <div className="relative flex-1 min-h-[280px] grid grid-cols-1 items-center">
      <div className="relative w-full max-w-[540px] mx-auto" style={{ aspectRatio: '16 / 9' }}>
        <svg viewBox="0 0 540 300" className="w-full h-full block" style={{ overflow: 'visible' }} aria-hidden="true">
          <defs>
            <linearGradient id="funnelFill" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#7ac142" stopOpacity="0.18" />
              <stop offset="100%" stopColor="#7ac142" stopOpacity="0.04" />
            </linearGradient>
            <linearGradient id="recoverStroke" x1="0" x2="1" y1="0" y2="0">
              <stop offset="0%" stopColor="#c9912a" />
              <stop offset="100%" stopColor="#5b8a3a" />
            </linearGradient>
          </defs>

          <path
            d="M70,60 L470,60 L330,200 L330,260 L210,260 L210,200 Z"
            fill="url(#funnelFill)"
            stroke="#5b8a3a"
            strokeOpacity="0.55"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />

          <text x="80" y="50" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="1.6" fill="#5a625f">VISITORS</text>
          <text x="395" y="50" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="1.6" fill="#5a625f" textAnchor="end">100%</text>
          <text x="270" y="285" fontFamily="JetBrains Mono, monospace" fontSize="10" letterSpacing="1.6" fill="#5a625f" textAnchor="middle">CONVERTED · 8%</text>

          <g opacity="0.95">
            <circle cx="475" cy="120" r="3.2" fill="#c9912a" />
            <circle cx="495" cy="138" r="2.6" fill="#c9912a" opacity="0.7" />
            <circle cx="510" cy="160" r="2.2" fill="#c9912a" opacity="0.55" />
            <circle cx="488" cy="172" r="3" fill="#c9912a" opacity="0.85" />
            <circle cx="515" cy="190" r="2" fill="#c9912a" opacity="0.5" />
          </g>
          <g opacity="0.95">
            <circle cx="65" cy="120" r="3.2" fill="#c9912a" />
            <circle cx="45" cy="138" r="2.6" fill="#c9912a" opacity="0.7" />
            <circle cx="30" cy="160" r="2.2" fill="#c9912a" opacity="0.55" />
            <circle cx="52" cy="172" r="3" fill="#c9912a" opacity="0.85" />
            <circle cx="25" cy="190" r="2" fill="#c9912a" opacity="0.5" />
          </g>

          <path d="M510,165 C540,90 470,30 360,55" fill="none" stroke="url(#recoverStroke)" strokeWidth="1.6" strokeDasharray="3 4" strokeLinecap="round" />
          <path d="M30,165 C0,90 70,30 180,55" fill="none" stroke="url(#recoverStroke)" strokeWidth="1.6" strokeDasharray="3 4" strokeLinecap="round" />

          <path d="M360,55 l-8,-3 l3,8 z" fill="#5b8a3a" />
          <path d="M180,55 l8,-3 l-3,8 z" fill="#5b8a3a" />

          <path d="M210,200 L330,200 L330,260 L210,260 Z" fill="#7ac142" fillOpacity="0.18" stroke="#5b8a3a" strokeOpacity="0.7" strokeWidth="1.2" />
        </svg>

        <div className="float-card animate-floaty-1" style={{ top: '6%', left: '2%' }}>
          <span className="dot amber" />
          <span><b>Cart abandoned</b> &middot; <small>2m ago</small></span>
        </div>
        <div className="float-card animate-floaty-2" style={{ top: '38%', right: '0%' }}>
          <span className="dot" />
          <span><b>Visitor identified</b> &middot; <small>j.lee@…</small></span>
        </div>
        <div className="float-card animate-floaty-3" style={{ bottom: '4%', left: '10%' }}>
          <span className="dot gray" />
          <span><b>Recovery email queued</b></span>
        </div>
        <div className="float-card animate-floaty-4" style={{ top: '14%', right: '12%' }}>
          <span className="dot" />
          <span><b>Returned & converted</b> &middot; <small>$248</small></span>
        </div>
      </div>
    </div>

    <div className="relative grid grid-cols-3 gap-px bg-mov-line border border-mov-line-strong rounded-md2 overflow-hidden shadow-card">
      <div className="bg-mov-paper px-[18px] py-[18px]">
        <div className="mono text-[10px] uppercase text-mov-ink-mute mb-2" style={{ letterSpacing: '0.12em' }}>Identified</div>
        <div className="display text-[30px] leading-none text-mov-ink flex items-baseline gap-1">
          12.4<span className="text-[13px] font-medium text-mov-ink-mute" style={{ fontFamily: '"Inter Tight", sans-serif' }}>k</span>
        </div>
        <div className="mono text-[10.5px] mt-1.5 text-mov-green-deep">▲ 18% wk</div>
      </div>
      <div className="bg-mov-paper px-[18px] py-[18px]">
        <div className="mono text-[10px] uppercase text-mov-ink-mute mb-2" style={{ letterSpacing: '0.12em' }}>Recovered</div>
        <div className="display text-[30px] leading-none text-mov-ink flex items-baseline gap-1">
          3.1<span className="text-[13px] font-medium text-mov-ink-mute" style={{ fontFamily: '"Inter Tight", sans-serif' }}>k</span>
        </div>
        <div className="mono text-[10.5px] mt-1.5 text-mov-green-deep">▲ 22% wk</div>
      </div>
      <div className="bg-mov-paper px-[18px] py-[18px]">
        <div className="mono text-[10px] uppercase text-mov-ink-mute mb-2" style={{ letterSpacing: '0.12em' }}>Revenue</div>
        <div className="display text-[30px] leading-none text-mov-ink flex items-baseline gap-1">
          $84<span className="text-[13px] font-medium text-mov-ink-mute" style={{ fontFamily: '"Inter Tight", sans-serif' }}>k</span>
        </div>
        <div className="mono text-[10.5px] mt-1.5 text-mov-green-deep">▲ 31% wk</div>
      </div>
    </div>
  </aside>
);

export default AuthVisualPanel;
